export const entitiesExport = {
  CONTACTS: 'contacts',
  HOSPITALS: 'hospitals',
  EVENTOS: 'eventos',
  LEADS: 'crms',
  PRESENTATIONS: 'presentations',
  ARTICLES: 'articles',
  USERS: 'users',
  CATEGORIES: 'categories',
}
